import { useQuery } from "@tanstack/react-query";
import { getPubDevCiqPublisherMapping } from "../api.js";

export const usePubDevCiqPublisherMapping = (influencerSignupToken) =>
  useQuery({
    queryKey: ["pubdev-ciq-publisher-mapping", influencerSignupToken],
    queryFn: () => getPubDevCiqPublisherMapping(influencerSignupToken),
    enabled: !!influencerSignupToken,
  });
